import { useCallback } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';
import { noop } from '@core/js/utils/methods.util';

import { USER_PHASES } from '@interlayer/js/app/hooks/auth/constants';
import { checkAccountBusinessPhase } from '@interlayer/js/app/hooks/user/server';

const phases = [USER_PHASES.preRegistered, USER_PHASES.inShop, [USER_PHASES.online, USER_PHASES.multiChannel]];

export const useCheckMembership = ({ handlerFoundUser = noop } = {}) => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (membershipNumber: string) => {
        try {
            for (let index = 0; index < phases.length; index++) {
                const phase = phases[index];
                const isOnlinePhase = Array.isArray(phase);

                // eslint-disable-next-line no-await-in-loop
                const response = await checkAccountBusinessPhase({
                    businessPhase: phase,
                    field: ['username'],
                    casinoName,
                    [isOnlinePhase ? 'username' : 'tokenCode']: membershipNumber
                });

                if (response.data?.resultCount) {
                    if (Array.isArray(phase)) {
                        handlerFoundUser();
                        return false;
                    }

                    return phase;
                }
            }

            return false;
        } catch (e) {
            return false;
        }
    }, [casinoName, handlerFoundUser]);
};

